<div *ngIf="buttonVisible">
    <button mat-menu-item (click)="execute()">
        <mat-icon>{{ iconName }}</mat-icon>
        <span>{{ buttonText }}</span>
    </button>
</div>
